import React from "react";

const GiftSVG = ({ className }) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="12.409"
      height="19.445"
      viewBox="0 0 12.409 19.445"
    >
      <g transform="translate(-1017.258 -281.492)">
        <path
          fill="none"
          stroke="#292929"
          strokeWidth="0.4"
          d="M1022.691 281.708c-.325.087-.408.238-.451.425s-4.605 15.186-4.719 15.584-.074.63.072.776a52.33 52.33 0 006.054 2.243 28.856 28.856 0 004.765-2.243c.116-.166.422-.24.312-1.583s-.212-2.886-.2-3.909.4-6.394.607-7.712a8.9 8.9 0 00.315-2.462c-.123-.442-.219-.721-.46-.814s-5.97-.392-6.295-.305z"
          data-name="Path 135"
        ></path>
        <path
          fill="#292929"
          stroke="#292929"
          strokeWidth="0.4"
          d="M1022.542 282.741s-.309.028-.344.24-4.176 13.887-4.176 13.887-.119.24 0 .392 4.528 1.614 4.639 1.62.384.227.6-.466 4.329-15.021 4.329-15.021a.27.27 0 00-.23-.363c-.325-.056-4.818-.289-4.818-.289z"
          data-name="Path 136"
        ></path>
        <path
          fill="#fff"
          d="M1057.274 319.152c-.146.039-2.943 9.483-2.866 9.554s4.151 1.041 4.3 1.061 3.114-10.175 3.034-10.215-4.322-.439-4.468-.4z"
          data-name="Path 137"
          transform="translate(-34.866 -35.344)"
        ></path>
        <path
          fill="none"
          stroke="#292929"
          strokeWidth="0.4"
          d="M1029.183 282.171s-.493 2.206-.579 3.248a93.083 93.083 0 00-.542 10.063c.21 2.244.354 3.034.354 3.034"
          data-name="Path 138"
        ></path>
      </g>
    </svg>
  );
};

export default GiftSVG;
